import React from 'react';
interface BannerSpec {
  width: number;
  height: number;
  ratio: string;
}
interface OffersBannerRowProps {
  columns: number;
  bannerSpec: BannerSpec;
  count: number;
  imageUrls?: string[];
  className?: string;
}
export function OffersBannerRow({
  columns,
  bannerSpec,
  count,
  imageUrls = [],
  className = ''
}: OffersBannerRowProps) {
  const banners = Array.from({
    length: count
  }, (_, i) => i + 1);
  const aspectRatio = bannerSpec.height / bannerSpec.width * 100;
  return <div className={`container mx-auto px-4 ${className}`} data-id="element-4679" data-mp="1z97k06aazth">
      <div className={`hidden md:grid gap-3 md:gap-4`} style={{
      gridTemplateColumns: `repeat(${columns}, 1fr)`
    }} data-id="element-4680" data-mp="3j6cq6uppdfqu">
        {banners.map(num => <a key={num} href="#" className="relative overflow-hidden rounded-lg bg-gray-300" data-id="element-4681" data-mp="3o793fyvy2e8x">
            <div className="w-full" style={{
          paddingTop: `${aspectRatio}%`
        }} data-id="element-4682" data-mp="1meb7hu6vf5jr" />
            {imageUrls[num - 1] && <img src={imageUrls[num - 1]} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-4683" data-mp="3ltl8rpq10enf" />}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-4684" data-mp="3qlmgcyc91h74">
              <div className="text-center text-gray-700" data-id="element-4685" data-mp="3qnpfq8zakmoi">
                <div className="text-2xl font-bold mb-2" data-id="element-4686" data-mp="32x3diybyxwmf">Banner {num}</div>
                <div className="text-sm" data-id="element-4687" data-mp="2xxgvmbl73s7a">Click to explore</div>
              </div>
            </div>
            <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded" data-id="element-4688" data-mp="3bx87o6s5iyin">
              {bannerSpec.width}×{bannerSpec.height} — {bannerSpec.ratio}
            </div>
          </a>)}
      </div>
      <div className="md:hidden -mx-4" data-id="element-4689" data-mp="r4wmfxgan39b">
        <div className="overflow-x-auto scrollbar-hide px-4" data-id="element-4690" data-mp="n4w5a51t8dyk">
          <div className="flex gap-3 pb-2" data-id="element-4691" data-mp="n4mhmo48miw1">
            {banners.map(num => <a key={num} href="#" className="relative flex-shrink-0 overflow-hidden rounded-lg bg-gray-300" style={{
            width: columns > 4 ? '150px' : '280px'
          }} data-id="element-4692" data-mp="3fyl101o6l373">
                <div className="w-full" style={{
              paddingTop: `${aspectRatio}%`
            }} data-id="element-4693" data-mp="3pvpllx2doqls" />
                {imageUrls[num - 1] && <img src={imageUrls[num - 1]} alt="" className="absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-4694" data-mp="2x9eo4va2j5t7" />}
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-4695" data-mp="3b09thxlcz4s1">
                  <div className="text-center text-gray-700" data-id="element-4696" data-mp="3b24efbwmqww4">
                    <div className="text-lg font-bold mb-1" data-id="element-4697" data-mp="2ehltkwfcpcjd">Banner {num}</div>
                    <div className="text-xs" data-id="element-4698" data-mp="2ij74ic8brgqx">Tap to view</div>
                  </div>
                </div>
                <div className="absolute bottom-2 left-2 bg-black bg-opacity-60 text-white text-xs px-2 py-1 rounded" data-id="element-4699" data-mp="2azeq22v9oo59">
                  {bannerSpec.ratio}
                </div>
              </a>)}
          </div>
        </div>
      </div>
      <style jsx data-id="element-4700" data-mp="221m7mpu910dn">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
}